<div
    *transloco="let t; prefix: 'uiCard'"
    class="flex md:items-center flex-col md:flex-row gap-5 md:gap-6 p-6 bg-white dark:bg-primary! rounded-2xl bg-clip-border">
    <big-ui-chart-circular-progress-bar [angle]="(data.status.progress / data.status.max) * 360">
        <div class="leading-4 text-center wrap-normal pt-[5px]">
            <div class="text-xs">{{ data.status.text }}</div>
            <div class="h4 mb-0 -mt-0.5">{{ data.status.progress }}/{{ data.status.max }}</div>
        </div>
    </big-ui-chart-circular-progress-bar>
    <div class="flex flex-col flex-auto">
        <h5 class="mb-1 md:mb-2">{{ data.title }}</h5>
        <div class="flex flex-col justify-between sm:flex-row gap-1">
            <span
                class="font-semibold"
                [textContent]="[t('received'), t('inProgress'), t('completed')][data.status.progress - 1]"></span>
            <span>{{ t('entry') }}: {{ data.created | date: 'dd.LL.yyyy' }}</span>
        </div>
    </div>
</div>
